export default {
  discount_types: {
    cashback: 'Loyalitetspoint',
    promo_code: 'Rabatkode',
  },
  input: {
    label: '{{cashbackLabel}} eller {{promoCodeLabel}}',
    placeholder: 'Rabatkode',
  },
  buttons: {
    apply: 'Anvend',
    remove: 'Fjern',
  },
  feedback: {
    login:
      '<highlight>Log ind</highlight> for at bruge denne rabatkode, så vi kan sikre, at du ikke har brugt den før. Log ind og prøv igen.',
    usage_threshold: 'Minimumsbeløb for kurven med denne rabatkode er (ekskl. leveringsgebyr)',
    promo_code_added: 'Rabatkoden er anvendt',
  },
};
